module.exports = __webpack_public_path__ + "assets/robot.2f12374b.svg";